<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Generate encryption key</span>
                <span class="default-settings-subtitle">Generate a new encryption key to encrypt your backups.</span>
            </div>
            <!-- <div class="default-settings-description">
                In order to connect with a new account, select one of the providers below.
            </div> -->

            <div class="backup">
                <div class="columns is-multiline">
                    <div class="column is-full">
                        <div class="field">
                            <input v-model="name" @keyup.enter="createEncryptionKey" type="text" :disabled="creatingEncryptionKey" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Friendly name" autocomplete="off"/>
                            <span v-if="!hasError('name')" class="help">A name to easily recognize the encryption key later.</span>
                            <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
                        </div>
                    </div>
                    <div class="column is-full">
                        <div class="field" @click="toggleConfirmation">
                            <input v-model="confirmed" type="checkbox" class="switch is-rounded is-info">
                            <label style="margin-top:-5px; font-size: 15px;">I understand that the private key must be stored in a secure location because it's the single way to decrypt my backups.</label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 20px;">
                <div class="column is-3">
                    <div @click="createEncryptionKey" :disabled="creatingEncryptionKey || !confirmed" :class="{ 'is-loading': creatingEncryptionKey }" class="button custom-button-size is-fullwidth is-info">Generate encryption key</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="creatingEncryptionKey">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            allowedInputs: ['name'],
            creatingEncryptionKey: false,
            name: '',
            confirmed: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        close() {
            if (!this.creatingEncryptionKey) {
                Event.$emit('generateEncryptionKeyModalClosed');
            }
        },

        createEncryptionKey() {
            if (this.creatingEncryptionKey || !this.confirmed) {
                return;
            }

            this.creatingEncryptionKey = true;
            this.resetErrors();

            Api().post('encryption-keys', { name: this.name })
                .then((success) => {
                    Event.$emit('refreshEncryptionKeys', () => {
                        this.close();
                        swal('Great!', 'The new encryption key was generated. Keep it in a safe place because it\'s the only way you will be able to decrypt the backups that will use it.', 'success');

                        window.open('https://api.weap.io/api/encryption-keys/' + success.data.data.id + '/private-key', '_blank');
                    });
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.creatingEncryptionKey = false;
                });
        },

        toggleConfirmation() {
            if (this.creatingEncryptionKey) {
                return;
            }

            this.confirmed = !this.confirmed;
        },

        listenEvents() {
            var vm = this;

            Event.$on('showGenerateEncryptionKeyModal', () => {
                vm.active = true;
            });
        },

        providerIsSelected(providerSlug) {
            return this.selectedProviderSlug === providerSlug;
        },

        selectProvider(providerSlug) {
            this.selectedProviderSlug = providerSlug;
        },
    },

    computed: {
        //
    },
}
</script>
